export const SERVICE_CASE_PDF_COLUMNS = [
  'caseNumber',
  'branch',
  'state',
  'scheduledCheckinDate',
  'vehicle',
  'vehicleRegistrationPlate',
  'vehicleVin',
  'customerName',
  'customerVehicleUser',
  'markers',
  'serviceCaseJob',
] as const;
